
//#region package.json
var name = "@prismicio/client";
var version = "7.21.6";

//#endregion
Object.defineProperty(exports, 'name', {
  enumerable: true,
  get: function () {
    return name;
  }
});
Object.defineProperty(exports, 'version', {
  enumerable: true,
  get: function () {
    return version;
  }
});
//# sourceMappingURL=package.cjs.map